/**
 * Converts the top-level keys of an object from camelCase to snake_case.
 * @param {Object} obj - The object to process.
 * @returns {Object} - A new object with snake_cased keys.
 */
export function convertKeysToSnakeCase(obj, initialObject = {}) {
  const newObj: any = {
    ...initialObject
  };
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const snakeCasedKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      newObj[snakeCasedKey] = obj[key];
    }
  }
  return newObj;
}
